export const SOFTLINE_PERMISSION_MDE_INVENTORY = 'INVENTUR';
export const SOFTLINE_PERMISSION_MDE_INVENTORY_SCAN_ADD_QUANTITY = 'INVENTUR.SCAN_DIREKT_ADDIEREN';
